import { InitialiserResult } from '../../types/InitialiserResult';
import { ModelWidgetOptions } from '../../types/ModelWidgetOptions';

import { enrichModelWidgetWithAiredaleInfo } from './getAiredaleInfo/enrichModelWidgetWithAiredaleInfo';
import { getModelWidget } from './getModelWidget';
import { getModelWidgetData } from './getModelWidgetData';
import { setupBattle } from './setupBattle';
import { setupTabBasedData } from './setupTabBasedData';
import { shouldRefetchData } from './shouldRefetchData';
import { updateWidgetConfig } from './updateWidgetConfig';

export default async (options: ModelWidgetOptions): Promise<InitialiserResult> => {
  const modelData = await getModelWidgetData(options);
  const updatedModelData = updateWidgetConfig(modelData);
  const dataWithBattleTest = setupBattle(updatedModelData);
  const dataWithChangedWidget = shouldRefetchData(dataWithBattleTest);
  const tabBasedData = await setupTabBasedData(dataWithChangedWidget);
  const airedaleInfoData = await enrichModelWidgetWithAiredaleInfo(tabBasedData);
  return getModelWidget(airedaleInfoData);
};
